var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75.217,
    height: 75.217,
    viewBox: "0 0 75.217 75.217",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".c7d637d275668ed6d41a9b97e6ad3a556{fill:none;stroke:currentColor;stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-16.554 -16.554)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c7d637d275668ed6d41a9b97e6ad3a556",
    d: "M40.109,40.109A18.054,18.054,0,1,0,22.054,22.054,18.049,18.049,0,0,0,40.109,40.109Zm0,9.027C28.057,49.136,4,55.184,4,67.19V71.7a4.527,4.527,0,0,0,4.514,4.514H71.7A4.527,4.527,0,0,0,76.217,71.7V67.19C76.217,55.184,52.16,49.136,40.109,49.136Z",
    transform: "translate(14.054 14.054)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.d617da276a3eecfd739a39525eb7d430.svg";
export { ForwardRef as ReactComponent };